import React, { useRef } from "react"
import logo from "/mm_logo.png"
import styles from "./C_AddressSlip.module.css"
import { useReactToPrint } from "react-to-print"
import { decodeHtml } from "../../../common/utils/address.util"

const C_AddressSlip = ({ orders, setAddressSlipClicked }) => {
  const contentToPrint = useRef(null)
  const verifiedOrders = orders.filter(
    (x) => x.order_statuses?.[0]?.status === "Payment Verified"
  )

  const handlePrint = useReactToPrint({
    documentTitle: `delivery_slip_${new Date().toLocaleDateString()}`,
    contentRef: contentToPrint, // v3+ way
    onAfterPrint: () => setAddressSlipClicked(false),
  })

  const triggerMobilePdf = () => {
    const element = document.getElementById("printable-address-slip-area") || contentToPrint.current
    const opt = {
      margin: 0.2,
      filename: `delivery_slips_${new Date().toISOString().slice(0, 10)}.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2, useCORS: true },
      jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
    }

    const runPdfSave = () => {
      if (window.html2pdf) {
        window.html2pdf().set(opt).from(element).save()
      } else {
        if (typeof handlePrint === "function") {
          handlePrint()
        } else {
          window.print()
        }
      }
    }

    if (window.html2pdf) {
      runPdfSave()
    } else {
      const script = document.createElement("script")
      script.src = "https://cdnjs.cloudflare.com/ajax/libs/html2pdf.js/0.10.1/html2pdf.bundle.min.js"
      script.onload = runPdfSave
      script.onerror = () => {
        if (typeof handlePrint === "function") handlePrint()
        else window.print()
      }
      document.body.appendChild(script)
    }
  }

  return (
    <>
      <div className={styles.toolbar}>
        <button
          type="button"
          onClick={() => {
            const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
              navigator.userAgent
            )
            if (isMobile) {
              triggerMobilePdf()
            } else {
              if (typeof handlePrint === "function") handlePrint()
              else window.print()
            }
          }}
          className={styles.printBtn}
        >
          🖨️ Print / Download PDF
        </button>
        <button
          type="button"
          onClick={() => setAddressSlipClicked(false)}
          className={styles.closeBtn}
        >
          Close
        </button>
      </div>
      <div
        ref={contentToPrint}
        id="printable-address-slip-area"
        className={styles.slipContainer}
      >
        {verifiedOrders.length === 0 ? (
          <div style={{ textAlign: "center", padding: "40px 20px", color: "#64748b" }}>
            <p style={{ fontSize: "1.1rem", fontWeight: 600, margin: "0 0 8px 0", color: "#1e293b" }}>
              No "Payment Verified" Orders
            </p>
            <p style={{ margin: 0, fontSize: "0.9rem" }}>
              Address slips can only be generated for orders with verified payment status.
            </p>
          </div>
        ) : (
          verifiedOrders.map((order) => (
            <div key={order.id} className={styles.addressSlipOuter}>
              <div className={styles.address_flex}>
                <div className={styles.addressSlip_logo}>
                  <img src={logo} alt="logo" />
                </div>
                <div>Invoice# {order.id}</div>
              </div>
              <div>BNPL CUSTOMER ID : 3000058092 SPEED POST</div>
              <div className={styles.address_flex}>
                <div>
                  <div>From:</div>
                  <div>Dr. Malu Mahendran's</div>
                  <div>Herbal Manufacturing unit</div>
                  <div>185/6</div>
                  <div>TVPURAM</div>
                  <div>686606</div>
                  <div>KOTTAYAM</div>
                  <div>KERALA</div>
                </div>
                <div style={{ textAlign: "right" }}>
                  <div>
                    Invoice date : {new Date().toDateString().substring(3)}
                  </div>
                  <div>Order id : {order.id}</div>
                  <div>
                    Order Date :
                    {new Date(order.created_at).toDateString().substring(3)}
                  </div>
                </div>
              </div>
              <div className={styles.address_flex}>
                <div>
                  <div>Phone : 9995464012</div>
                  <div>Email : drmmherbalsenquiry@gmail.com</div>
                </div>
                <div className={styles.shippingAddress}>
                  <h3>To:</h3>
                  <h3>Shipping Address :</h3>
                  <div>{decodeHtml(order.name)}</div>
                  <div>{decodeHtml(order.line_1)}</div>
                  <div>{decodeHtml(order.line_2)}</div>
                  <div>
                    {decodeHtml(order.city)}, {decodeHtml(order.district)}
                  </div>
                  <div>
                    {decodeHtml(order.state)}, {decodeHtml(order.country)} - {order.pin_code}
                  </div>
                  <div>{order.phone_number}</div>
                </div>
              </div>
              <div>
                <div>Order Summary</div>
                <table className={styles.addressSlip_table}>
                  <thead>
                    <tr>
                      <th>Item</th>
                      <th>Quantity</th>
                    </tr>
                  </thead>
                  <tbody>
                    {order.order_products.map((item) => (
                      <tr key={item.id}>
                        <td className={styles.addressSlip_td}>
                          <div>
                            <div>
                              <img
                                width={30}
                                src={`${
                                  import.meta.env.VITE_BACKEND_URL
                                }/public/images/products/${
                                  item.Product.product_images[0]?.image_url
                                }`}
                                alt={item.Product.product_images[0]?.image_url}
                              />
                            </div>
                            <div>{decodeHtml(item.Product.name)}</div>
                          </div>
                        </td>
                        <td>{item.qty}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div style={{ pageBreakBefore: "always" }}></div>
              {/* <hr /> */}
            </div>
          ))
        )}
      </div>
    </>
  )
}

export default C_AddressSlip
